// extracted by mini-css-extract-plugin
module.exports =  {"skeleton-pulse":"di0NiCeX","skeleton-wave":"V5XbGEp8","skeleton":"P7DhqBp9","pulse":"yoc0IcHJ","wave":"uv8dAvvm","none":"P3v_TQuA"};